function toIsoFormat(date: string, time: string): string {
  // Cria um objeto Date com a data e hora locais
  const [year, month, day] = date.split("-").map(Number);
  const [hours, minutes] = time.split(":").map(Number);

  const localDate = new Date(year, month - 1, day, hours, minutes);

  // Converte para string ISO
  return localDate.toISOString();
}

function fromIsoFormat(isoStr: string | null): {
  date: string;
  time: string;
} {
  if (!isoStr) return { date: "", time: "" };
  const localDateTime = new Date(isoStr);
  if (Number.isNaN(localDateTime.getTime())) return { date: "", time: "" };

  // Formatar a data no formato YYYY-MM-DD
  const year = localDateTime.getFullYear();
  const month = String(localDateTime.getMonth() + 1).padStart(2, "0");
  const day = String(localDateTime.getDate()).padStart(2, "0");
  const date = `${year}-${month}-${day}`;

  // Formatar a hora no formato HH:MM
  const hours = String(localDateTime.getHours()).padStart(2, "0");
  const minutes = String(localDateTime.getMinutes()).padStart(2, "0");
  const time = `${hours}:${minutes}`;

  return { date, time };
}

export const DateTimeHelper = {
  toIsoFormat,
  fromIsoFormat,
};
